import React from 'react';
export const Story = () => {
  return <div className="py-16 bg-white relative" data-id="element-205">
      {/* American flag corner element */}
      <div className="absolute top-0 right-0 w-16 h-16 md:w-24 md:h-24 overflow-hidden" data-id="element-206">
        <div className="relative w-full h-full" data-id="element-207">
          {/* Red and white stripes */}
          <div className="absolute top-0 left-0 w-full h-full flex flex-col" data-id="element-208">
            {[...Array(13)].map((_, i) => <div key={i} className={`w-full ${i % 2 === 0 ? 'bg-red-700' : 'bg-white'}`} style={{
            height: `${100 / 13}%`
          }} data-id="element-209"></div>)}
          </div>
          {/* Blue canton with stars - now positioned on the left */}
          <div className="absolute top-0 left-0 w-2/5 h-7/13 bg-blue-800" data-id="element-210">
            <div className="w-full h-full flex flex-wrap justify-center items-center p-0.5" data-id="element-211">
              {/* Grid of stars - simplified to 9 stars (3x3 grid) */}
              <div className="grid grid-cols-3 gap-0.5 w-full h-full" data-id="element-212">
                {[...Array(9)].map((_, i) => <div key={i} className="flex items-center justify-center" data-id="element-213">
                    <svg className="w-1.5 h-1.5 md:w-2 md:h-2 text-white" fill="currentColor" viewBox="0 0 24 24" data-id="element-214">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-215" />
                    </svg>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-216">
        <p className="text-lg text-gray-700 mb-8" data-id="element-217">
          Some leaders are born, others are forged through adversity. Donald
          Trump's journey from business magnate to the most influential
          political figure of our time represents the American spirit at its
          finest - bold, unapologetic, and committed to putting America first.
        </p>
        <p className="text-lg text-gray-700 mb-8" data-id="element-218">
          Alongside him, Charlie Kirk emerged as a voice for young
          conservatives, building a movement that would reshape the political
          landscape for a new generation. Against all odds and facing
          unprecedented opposition, they transformed American politics forever.
        </p>
        <p className="text-lg text-gray-700 mb-12" data-id="element-219">
          Today, their legacy stands as a testament to American resilience—and
          now their remarkable story is revealed in{' '}
          <span className="italic font-medium" data-id="element-220">The Last Patriot</span> by Jason
          Goodman.
        </p>
        <div className="bg-blue-50 border-l-4 border-blue-700 p-6 mb-12" data-id="element-221">
          <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-222">
            <span className="text-red-700 mr-2" data-id="element-223">★</span>
            The partnership that changed America
          </h3>
          <p className="text-lg text-gray-700 mb-4" data-id="element-224">
            At a time when many politicians catered to special interests, Trump
            and Kirk asked:
          </p>
          <blockquote className="text-xl italic font-medium text-gray-800 pl-4 border-l-4 border-red-700 my-6" data-id="element-225">
            "When was the last time America won? When did we actually beat China
            in a trade deal? When did we secure our border? When did we put
            America first?"
          </blockquote>
          <p className="text-lg text-gray-700" data-id="element-226">
            Those questions didn't just spark debate—they ignited a movement to
            restore American greatness and traditional values.
          </p>
        </div>
        <div className="flex justify-center my-12 relative" data-id="element-227">
          <div className="absolute inset-0 rounded-lg border-4 border-transparent bg-gradient-to-r from-red-700 via-white to-blue-700 opacity-50" data-id="element-228"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6ykg7fA9XvWgjMNA9u4WP1/Bookshelf_last_patriot.png" alt="The Last Patriot book on bookshelf" className="w-full max-w-2xl rounded-lg shadow-lg relative z-10" data-id="element-229" />
        </div>
      </div>
    </div>;
};